import React, {Component} from 'react';

import './Nav2017.css';

import logo from '../img/logo.png';

const $ = require('zeptojs');

export default class Nav2017 extends Component {
  componentDidMount() {
    $(window).scroll(function () {
      if (window.scrollY === 0) {
        $('.navbar').removeClass('navbar-black');
      }
      else {
        $('.navbar').addClass('navbar-black');
      }
    });
  }

  render() {
    return (
      <nav className="navbar navbar-fixed-top">
        <div className="container">
          <div className="col-xs-12">
            <div className="navbar-header">
              <img className="logo" alt="" src={logo} />
              <div className="title">坦安信息</div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Nav2017.js